import React, { useState } from "react";
import "./ChatAgent.css";
import { url } from "../../util/config";
import { chatData } from "./chat";

const ChatAgent = () => {
    const users = chatData;

    const [selectedNumber, setSelectedNumber] = useState("");
    const [userList, setUserList] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [newMessage, setNewMessage] = useState("")
    const [userData, setUserData] = useState(users);
    const handleSendMessage = () => {
        if (newMessage.trim() !== ""  && selectedUser) {
            const timestamp = new Date().toLocaleTimeString();
            const message = {
                message: newMessage,
                timestamp: timestamp,
                type: "sent"
            };

            setSelectedUser((prevUser) => {
                const updateChatMessage = [...prevUser.chatMessage, message];
                return {
                    ...prevUser,
                    chatMessage: updateChatMessage
                };
            });
            setNewMessage("");

            setUserList((prevList) => {
                return prevList.map((user) => {
                    if (user.mobile === selectedUser.mobile) {
                        return { ...user, chatMessage: [...user.chatMessage, message] };
                    }
                    return user
                });
            });
            console.log(userList)
        }
    }

    const handleDropdownChange = (e) => {
        setSelectedNumber(e.target.value);
    };

    const handleSubmit = () => {
        if (selectedNumber) {
            const selectedUser = userData.find((user) => user.mobile === selectedNumber);

            setUserList(selectedUser ? selectedUser.userInfo : []);
            setSelectedUser(selectedUser.userInfo[0]);
        }
    };

    const handleUserClick = (user) => {
        setSelectedUser(user);
    }

    return (
        <div style={{ display: "flex", height: "100vh", flexDirection: "column" }}>
            <div style={{ backgroundColor: "#111b21", padding: "10px", display: "flex", alignItems: "center", color: "#d1d7db" }}>
                <select 
                    value={selectedNumber}
                    onChange={handleDropdownChange}
                    style={{ padding: "8px", marginRight: "10px", borderRadius: "4px", border: "1px solid #2a3942", backgroundColor: "#202c33", color: "#d1d7db" }}
                >
                    <option value="">Select Mobile Number</option>
                    {userData.map((user, index) => (
                        <option key={index} value={user.mobile}>
                            {user.mobile}
                        </option>
                    ))}
                </select>
                <button 
                    onClick={handleSubmit}
                    style={{ padding: "8px 15px", borderRadius: "4px", border: "none", backgroundColor: "#00a884", color: "#fff", cursor: "pointer" }}
                >
                    Submit
                </button>
            </div>  
            <div className="chat-agent" style={{ display: "flex", flex: 1 }}>
                {/* Left Sidebar: User List */}
                <div className="user-list">
                    {userList.map((user, index) => (
                        <div 
                            key={index} 
                            className="user"
                            onClick={() => handleUserClick(user)}
                            style={{ cursor: "pointer", padding: "10px", borderBottom: "1px solid #ccc", display: "flex", alignItems: "center" }}
                        >
                            <img src={user.userImg} alt={user.name} className="user-image"
                                style={{ width: "40px", height: "40px", borderRadius: "50%", marginRight: "10px" }}
                            />
                            <span className="user-name">{user.name}</span>
                            <i 
                                className={`bi ${user.status === "Online" ? "bi-circle-fill text-success" : user.status === "Offline" ? "bi-circle-fill text-secondary" : "bi-circle-fill text-warning"}`}
                                style={{ marginLeft: "auto", fontSize: "12px" }}
                                title={user.status === "Online" ? "Online" : user.status === "Offline" ? "Offline" : "Busy"}      
                            ></i>
                        </div>
                    ))}
                </div>
                {/* Center: Chat Window */}
                <div className="chat-container">
                    <div className="chat-window">
                        {selectedUser ? (
                            selectedUser.chatMessage.map((message, index) => (
                                <div key={index} className={`message ${message.type}`}>
                                    <span className="message-content">{message.message}</span>
                                    <span className="timestamp">{message.timestamp}</span>
                                </div>
                            ))
                        ) : (
                            <div className="no-user">
                                Select a user to start chatting
                            </div>
                        )}
                    </div>
                    {/* Input Area */}
                    <div className="message-input">
                        <input 
                            type="text" 
                            value={newMessage} 
                            onChange={(e) => setNewMessage(e.target.value)} 
                            placeholder="Type a message..." 
                            className="input-box"
                            style={{borderRadius: "20px", flex: 1, padding: "10px", border: "1px solid #ccc", outline: "none"}}
                        />
                        <button 
                            onClick={handleSendMessage}
                            className="send-button"
                        >
                            <i className="fas fa-paper-plane"></i>
                        </button>
                    </div>
                </div>
                {/* Right Sidebar: User Details */}
                <div className="user-profile" style={{ flex: 1, padding: "10px"}}>
                    {selectedUser ? (
                        <>
                            <img
                                src={selectedUser.userImg} 
                                alt={selectedUser.name} 
                                className="profile-image"
                                style={{ width: "100px", height: "100px", borderRadius: "50%", marginBottom: "10px" }}
                            />
                            <h2>{selectedUser.name}</h2>
                            <p>Email: {selectedUser.email}</p>
                            <p>Phone: {selectedUser.phone}</p>
                            <p>About: {selectedUser.about}</p>
                        </>
                    ) : (
                        <div>Please select a user to view their profile</div>
                    )}
                </div>
            </div>  
        </div>
    );


}


export default ChatAgent;